// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__1TRGo","col":"CardReaderDesc_col__3QvB8","label":"CardReaderDesc_label__3TirX"};